<template>
  <div id="content">
    <Header></Header>
    <div id="app" class="container">
      <LoadingView v-if="isLoading"></LoadingView>
      <router-view @setLoading="setLoading" class="router d-flex justify-content-center"></router-view>
    </div>
  </div>
</template>

<script>
  import Header from "./components/Header";
  import LoadingView from "./components/LoadingView";

  export default {
      name: 'app',
      methods: {
          updateServerTime() {
              const url = this.$api_url + 'debug/localservertime'
              this.$http.get(url)
                  .then((result) => {
                      console.log(result);
                      this.localServerTime = result.data.time
                      this.isLoading = false
                  })
          },
          setLoading(value){
            this.isLoading = value;
          }
      },
      components: {
        LoadingView,
        Header,
      },
      mounted: function () {
        //this.updateServerTime()
      },
      data() {
          return {
              isLoading: false,
              loadingTitle: null,
              localServerTime: null,
          }
      }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #FFFFFF;
    background: transparent;
    margin-top: 5vh;
    font-family: 'Exo 2';
  }

  .row {
    margin-right: 0;
    margin-left: 0;
  }

  body{
    background: transparent;
    height: 100vh;
  }

  html, .loading {
    background: rgb(137,183,192);
    background: -moz-linear-gradient(159deg, rgba(137,183,192,1) 0%, rgba(85,157,177,1) 35%, rgba(42,113,134,1) 100%);
    background: -webkit-linear-gradient(159deg, rgba(137,183,192,1) 0%, rgba(85,157,177,1) 35%, rgba(42,113,134,1) 100%);
    background: linear-gradient(159deg, rgba(137,183,192,1) 0%, rgba(85,157,177,1) 35%, rgba(42,113,134,1) 100%);
    background-attachment: fixed;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#89b7c0",endColorstr="#2a7186",GradientType=1);
  }

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .router
  {

  }
</style>



// WEBPACK FOOTER //
// src/App.vue